import type { Entity } from 'ag-common-lib/lib/lists/entity-permission.enum';
import {
  EntityPermissionActivityKeys,
  type RoleEntityPermissionMap,
} from 'ag-common-lib/lib/models/utils/entity-permission.model';

export const hasPermissionGuard = (entities: Entity[], permissionMap: RoleEntityPermissionMap): boolean => {
  if (!entities || !entities?.length) {
    return false;
  }

  return entities.some(entity =>
    [EntityPermissionActivityKeys.read].some(activity => permissionMap?.[entity]?.[activity]),
  );
};
